import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "react-pro-sidebar/dist/css/styles.css";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import "react-datepicker/dist/react-datepicker.css";
import 'react-loading-skeleton/dist/skeleton.css'
// Diimpor paling akhir dari seluruh CSS: berisi token tema serta
// penimpaan permukaan Bootstrap, yang harus menang atas CSS Bootstrap
// yang diimpor di atasnya.
import './styles/global.scss'
import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
    applicationId: '47530d91-68c5-4949-9d37-5285519dcf5e',
    clientToken: 'pub9e6dd0789074d309652230db726cb178',
    site: 'datadoghq.com',
    service: 'mamboo-react',
    env: 'development',
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackBfcacheViews: true,
    defaultPrivacyLevel: 'mask-user-input',
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
